import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { FloatingButtons } from "./components/FloatingButtons";
import { ScrollToTop } from "./components/ScrollToTop";
import { Toaster } from "./components/ui/sonner";
import { Home } from "./pages/Home";
import { About } from "./pages/About";
import { Services } from "./pages/Services";
import { LegFootCare } from "./pages/services/LegFootCare";
import { LiverGI } from "./pages/services/LiverGI";
import { KidneyDialysis } from "./pages/services/KidneyDialysis";
import { WomensHealth } from "./pages/services/WomensHealth";
import { Emergency } from "./pages/services/Emergency";
import { Miscellaneous } from "./pages/services/Miscellaneous";
import { Qualifications } from "./pages/Qualifications";
import { Contact } from "./pages/Contact";
import { Testimonials } from "./pages/Testimonials";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/leg-foot-care" element={<LegFootCare />} />
            <Route path="/services/liver-gi" element={<LiverGI />} />
            <Route path="/services/kidney-dialysis" element={<KidneyDialysis />} />
            <Route path="/services/womens-health" element={<WomensHealth />} />
            <Route path="/services/emergency" element={<Emergency />} />
            <Route path="/services/miscellaneous" element={<Miscellaneous />} />
            <Route path="/qualifications" element={<Qualifications />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
        <FloatingButtons />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
